import { attachTabSync } from '@rocketlane/state-db';
import { getTabSync } from '../tab-sync';
import { statusUpdatesCollection } from './status-updates-collection';
export const attachStatusUpdatesTabSync = ()=>attachTabSync({
        collection: statusUpdatesCollection,
        sync: getTabSync()
    });
